export const TEMPLATE_NAME_FIELD = 'name'
export const TEMPLATE_DEPARTMENT_FIELD = 'department'

export const getDefaultValues = () => ({
  [TEMPLATE_NAME_FIELD]: '',
  [TEMPLATE_DEPARTMENT_FIELD]: null,
})
